// Determine whether an inpujt is active in the document
// or not (useful for overriding shortcuts)export const isInputActive = () =>
export const isInputActive = () =>
  document.activeElement &&
  (document.activeElement.nodeName.toLowerCase() === 'input' ||
    document.activeElement.nodeName.toLowerCase() === 'textarea' ||
    document.activeElement.attributes.contenteditable);
